export const TESTEGOR_TEST_HOSTNAME = "testegor.truckit.com";
export const TESTEGOR_TEST_PORTAL_DATA = {
    parentCompanyId: 662,
    parentCompanyUUID: "45254bc9-24d5-4184-9cf9-a1cb389418b6",
    tabTitle: "testegor title",
    customerRole: "testegor role customer",
};
